import { useState, useEffect, useRef } from "react";
import Axios from '@/shared/api/axios';
import Pagination from '@/components/ui/Pagination'
import StatusModal from '@/components/ui/StatusModal';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@/shared/utils/formatDate';

function ActivitySettings() {
  const { t } = useTranslation();

  const [pageParams, setPageParams] = useState({
    page: 1,
    limit: 10,
  });

  const [list, setList] = useState(null);
  const [total, setTotal] = useState(null);


  // API 非成功狀態碼統一由 StatusModal 顯示（含攔截器附加的 HTTP_xxx）
  const statusModalRef = useRef(null);
  const [currentStatusCode, setCurrentStatusCode] = useState('');

  const getList = async (pa) => {
    try {
      const res = await Axios.get("/user/get-activity-records", {
        params: pa
      });
      switch (res.data.status_code) {
        case 'SYSTEM_1000':
          setList(res.data.data);
          setTotal(res.data.total);
          break;
        default:
          setCurrentStatusCode(res.data.status_code);
          statusModalRef.current?.show();
          break
      }
    } catch (error) {
      // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
      if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
        setCurrentStatusCode(error.httpErrorCode);
        statusModalRef.current?.show();
      } else if (!error.httpErrorCode) {
        console.error('Get activity records error:', error);
      }
    }
  };

  const handlePageChange = (number) => {
    const newPageParams = { ...pageParams, page: number };
    setPageParams(newPageParams);
    getList(newPageParams);
  }

  useEffect(() => {
    getList(pageParams);
  }, [])

  return (
    <>
      <h3 className="mb-4">{t('activity_history')}</h3>
      <div className="row g-2 mb-4 p-3 bg-white rounded">
        {list && list.length > 0 ? (
          list.map((item, index) => (
            <div key={index + item.content}>
              <small className="text-gray me-1">{formatDateTime(item.created_at)} / {item.ip}</small>
              <span className="me-2 fw-bold">{item.action}</span>
              <span>{item.content}</span>
            </div>
          ))
        ) : t('no_data')}
      </div>
      {list && list.length > 0 ? (
        <Pagination
          total={total}
          limit={pageParams.limit}
          currentPage={pageParams.page}
          onPageChange={handlePageChange}
          scrollMode="window"
        />
      ) : ('')}
      <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    </>
  );

}

export default ActivitySettings;